import { DotOutlineIcon } from "@phosphor-icons/react";

export const createCampaignSteps = [
  { id: 1, label: "User Details" },
  { id: 2, label: "Request Details" }
];

export const approvalOptions = [
  {
    label: "Pending Approval",
    value: "pending_approval",
    icon: DotOutlineIcon,
    iconColor: "#F5A623"
  },
  {
    label: "Approved",
    value: "approved",
    icon: DotOutlineIcon,
    iconColor: "#28A745"
  },
  {
    label: "Rejected",
    value: "rejected",
    icon: DotOutlineIcon,
    iconColor: "#DC3545"
  }
];

// export const rejectReasonOptions = [
//   {
//     label: "Is targeted only at nano creators",
//     value: "is targeted only at nano creators"
//   },
//   {
//     label: "Offers low-value barter",
//     value: "offers low value barter"
//   },
//   {
//     label: "Appears to be inauthentic or misleading",
//     value: "appears to be inauthentic or misleading"
//   },
//   {
//     label: "Focuses on collecting creator contact information",
//     value: "focuses on collecting creator contact information"
//   }
// ];

export const rejectReasonOptions = [
  {
    label: "Is targeted only at nano creators",
    value: "reason_1",
    apiValue: "is targeted only at nano creators"
  },
  {
    label: "Offers low-value barter",
    value: "reason_2",
    apiValue: "offers low-value barter"
  },
  {
    label: "Appears to be inauthentic or misleading",
    value: "reason_3",
    apiValue: "appears to be inauthentic or misleading"
  },
  {
    label: "Focuses on collecting creator contact information",
    value: "reason_4",
    apiValue: "focuses on collecting creator contact information"
  }
];

// constants/selectOptions.js
export const selectOptionsMap = {
  service_type: [
    {
      label: "Influencer Marketing Agencies",
      value: "influencer_marketing_agencies"
    },
    {
      label: "Photographers / Videographers",
      value: "photographers_videographers"
    },
    {
      label: "Talent Management Agencies",
      value: "talent_management_agencies"
    },
    {
      label: "General Marketing Services",
      value: "general_marketing_services"
    },
    { label: "Others", value: "others" },
    { label: "Influencers", value: "influencers" }
  ],

  brand_info: [
    {
      label: "Brand name",
      value: "brand_name"
    },
    {
      label: "Brand type",
      value: "brand_type"
    }
  ],

  budget_type: [
    {
      label: "Overall Budget",
      value: "overall_budget"
    },
    {
      label: "Per Influencer",
      value: "per_influencer"
    }
  ],

  closed_via: [
    {
      label: "Hashfame",
      value: "hashfame"
    },
    {
      label: "Outside Hashfame",
      value: "outside_hashfame"
    }
  ],

  collaboration_type: [
    {
      label: "Paid",
      value: "paid"
    },
    {
      label: "Barter",
      value: "barter"
    },
    {
      label: "Others",
      value: "others"
    }
  ],

  status: [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" }
  ]
};

export const COLLABORATION_TYPE = [
  {
    label: "Paid",
    value: "paid"
  },
  {
    label: "Barter",
    value: "barter"
  },
  {
    label: "Others",
    value: "others"
  }
];

export const CREATOR_TYPES = ["Nano", "Micro", "Macro", "Mega", "Celeb"];

export const DEFAULT_FORM = {
  approval_status: "",
  retool_comments: "",
  service_type: "",
  platform: "",
  categories: [],
  languages: [],
  cities: [],
  is_pan_india: false,
  any_language: false,
  is_high_value: false,
  description: "",
  brand_info: "",
  brand: "",
  barter: false,
  creator_count_min: "",
  creator_count_max: "",
  budget_type: "",
  budget_min: "",
  budget_max: "",
  budget: "",
  is_open: false,
  creator_range: [],
  closed_via: ""
};

export const MARKETPLACE_APPROVE_OPTIONS = [
  {
    label: "Approve",
    value: "approved"
  },
  {
    label: "Approve & Post as Others",
    value: "approved_others",
    type: "others"
  },
  {
    label: "Approve & Post as Top Deal",
    value: "approved_top_deal",
    high_value: 1
  }
];

export const MARKETPLACE_REJECT_OPTIONS = [
  {
    label: "Reject",
    value: "rejected"
  }
];
